/**
 * Messaging Constants
 */

// Priority levels
export const PRIORITY_LEVELS = {
  HIGH: { value: 'HIGH', label: 'Haute', color: 'red', bgColor: 'bg-red-100', textColor: 'text-red-700', icon: '🔴' },
  NORMAL: { value: 'NORMAL', label: 'Normale', color: 'blue', bgColor: 'bg-blue-100', textColor: 'text-blue-700', icon: '🔵' },
  LOW: { value: 'LOW', label: 'Basse', color: 'gray', bgColor: 'bg-gray-100', textColor: 'text-gray-700', icon: '⚪' }
};

// Conversation statuses
export const CONVERSATION_STATUSES = {
  OPEN: { value: 'OPEN', label: 'Ouverte', color: 'blue' },
  RESOLVED: { value: 'RESOLVED', label: 'Résolue', color: 'green' },
  PENDING: { value: 'PENDING', label: 'En attente', color: 'yellow' }
};

// Default response templates (shared across staff)
export const DEFAULT_TEMPLATES = [
  {
    id: 'greeting',
    name: 'Salutation',
    category: 'general',
    content: 'Bonjour,\n\nMerci pour votre message. Comment puis-je vous aider ?'
  },
  {
    id: 'ack_request',
    name: 'Accusé réception demande',
    category: 'operations',
    content: 'Bonjour,\n\nNous avons bien reçu votre demande de transport. Notre équipe l\'examine actuellement et reviendra vers vous dans les plus brefs délais avec un devis détaillé.\n\nCordialement,\nL\'équipe Baobab Connect'
  },
  {
    id: 'quote_sent',
    name: 'Devis envoyé',
    category: 'operations',
    content: 'Bonjour,\n\nVotre devis est maintenant disponible dans votre espace client. Vous pouvez le consulter et l\'accepter directement depuis la plateforme.\n\nN\'hésitez pas à nous contacter pour toute question.\n\nCordialement,\nL\'équipe Baobab Connect'
  },
  {
    id: 'delivery_update',
    name: 'Mise à jour livraison',
    category: 'operations',
    content: 'Bonjour,\n\nVotre livraison est en cours. Voici les informations de suivi :\n\n[INSÉRER DÉTAILS]\n\nVous pouvez suivre votre colis en temps réel sur notre plateforme.\n\nCordialement,\nL\'équipe Baobab Connect'
  },
  {
    id: 'payment_reminder',
    name: 'Rappel paiement',
    category: 'finance',
    content: 'Bonjour,\n\nNous vous rappelons qu\'une facture est en attente de règlement. Vous pouvez effectuer le paiement via Wave depuis votre espace "Mes Finances".\n\nPour toute question, n\'hésitez pas à nous contacter.\n\nCordialement,\nL\'équipe Baobab Connect'
  },
  {
    id: 'closing',
    name: 'Clôture conversation',
    category: 'general',
    content: 'Merci pour votre confiance. N\'hésitez pas à nous recontacter si vous avez d\'autres questions.\n\nBonne journée !'
  }
];

// Template categories
export const TEMPLATE_CATEGORIES = {
  general: { label: 'Général', icon: '💬' },
  operations: { label: 'Opérations', icon: '🚚' },
  finance: { label: 'Finance', icon: '💰' },
  support: { label: 'Support', icon: '🛠️' }
};
